import React, { Component } from 'react';
import Parse                from 'parse';
import payment              from '../../../lib/jquery.payment';
import Utils                from '../../../Utils/Utility';
import Api                  from '../../../Utils/api';

export default class AddCard  extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props){
        super(props);
        this.state = {
            customerId      : '',
            locId           : '',
            zipCode         : '',
            customerDetails : {},
            error           : '',
            updateCardDetail : false
        }

        this.setStripeKey              = this.setStripeKey.bind(this);
        this.validateStripe            = this.validateStripe.bind(this);
        this.initializeCustomerDetails = this.initializeCustomerDetails.bind(this);
        this.createStripeCustomer      = this.createStripeCustomer.bind(this);
    }

    changeZipCode = (e) => {
        this.setState({
            zipCode : e.target.value
        });
    }

    setStripeKey(publishableKey){
        Stripe.setPublishableKey(publishableKey);
        $('[data-numeric]').payment('restrictNumeric');
        $('.cc-number').payment('formatCardNumber');
        $('.cc-exp').payment('formatCardExpiry');
        $('.cc-cvc').payment('formatCardCVC');
    }

    toggleInputError(elem,erred){
        elem.closest('.form-group').toggleClass('has-error', erred);
    }

    validateStripe(){

        let cardType = $.payment.cardType($('.cc-number').val());
        this.toggleInputError($('.cc-number'),!$.payment.validateCardNumber($('.cc-number').val()));
        this.toggleInputError($('.cc-exp'),!$.payment.validateCardExpiry($('.cc-exp').payment('cardExpiryVal')));
        this.toggleInputError($('.cc-cvc'),!$.payment.validateCardCVC($('.cc-cvc').val(), cardType));
        $('.cc-brand').text(cardType);
        $('.validation').removeClass('text-danger text-success');
        $('.validation').addClass($('.has-error').length ? 'text-danger' : 'text-success');
        return $('.has-error').length?false:true;

    }

    initializeCustomerDetails() {
        const currentUser = Parse.User.current();
        return {
            firstName          : currentUser.get("firstName"),
            lastName           : currentUser.get("lastName"),
            name               : currentUser.get("name"),
            email              : currentUser.get("email"),
            phone              : currentUser.get("phoneNumber"),
            zipCode            : this.state.zipCode
        };
    }

    componentWillMount() {
        let currentUser = Parse.User.current();
        this.setState({
            locIdBeingProcessed : currentUser.get("processLocId")
        });
    }

/*    componentWillReceiveProps(nextProps) {*/
        //if (nextProps.resetSuccessParam != this.props.resetSuccessParam) {
            //this.setState({
                //success    : this.props.resetSuccessParam
            //});
        //}
    /*}*/

    createStripeCustomer(e) {
        e.preventDefault();
        let self = this;
        let $form = $("#payment-form");

        if(!this.validateStripe()){
            return;
        }

        /* Visual feedback */
        $form.find('.payment').html('Validating <i class="fa fa-spinner fa-pulse"></i>').prop('disabled', true);


        /* Create token */
        let expiry = $form.find('[name=cc-exp]').payment('cardExpiryVal');

        const currentUser = Parse.User.current();

        let ccData = {
            number      : $form.find('[name=cc-number]').val().replace(/\s/g,''),
            cvc         : $form.find('[name=cc-cvc]').val(),
            exp_month   : expiry.month,
            address_zip : this.state.zipCode,
            name        : currentUser.get("name"),
            exp_year    : expiry.year
        };

        Stripe.card.createToken(ccData, function stripeResponseHandler(status, response) {
            if (response.error) {
                /* Visual feedback */
                $form.find('.payment').html('Try again').prop('disabled', false);
                /* Show Stripe errors on the form */
                $form.find('.payment-errors').text(response.error.message);
                $form.find('.payment-errors').closest('.row').show();
            } else {
                /* Visual feedback */
                $form.find('.payment').html('Processing <i class="fa fa-spinner fa-pulse"></i>');
                /* Hide Stripe errors on the form */
                $form.find('.payment-errors').closest('.row').hide();
                $form.find('.payment-errors').text("");
                // response contains id and card, which contains additional card details
                let token           = response.id;
                let userDetailPtrId = Parse.User.current().id;
                let sessionToken    = Parse.User.current().getSessionToken();
                let customerId      = self.state.customerId||"";
                let customerDetails = self.initializeCustomerDetails();
                let locId           = self.state.locId;


                Api.createOrUpdateCustomerOnStripe
                (locId, userDetailPtrId, sessionToken, customerId, customerDetails, token)
                    .then(
                        function(res){
                             self.props.callbackParent(res.data);
                             $form.find('.payment').html('Card added successfully <i class="fa fa-check"></i>');
                         },
                         function(errorRes){
                             Utils.checkErrorIsInvalidSessionToken(errorRes, self.context.router);
                             // this.setState({showSpinner : false });
                             if(errorRes && errorRes.responseJSON){
                                 self.setState({
                                     error:errorRes.responseJSON.error.message
                                 });
                             }
                             $form.find('.payment').html('There was a problem').removeClass('success').addClass('error');
                             /* Show Stripe errors on the form */
                             $form.find('.payment-errors').text('Try refreshing the page and trying again.');
                             $form.find('.payment-errors').closest('.row').show();
                         });
            }
        });
    }

    componentDidMount() {

        this.setStripeKey(PARSE_SP_KEY);
        this.setState({
            customerId       : this.props.customerId,
            locId            : this.props.locId,
            updateCardDetail : this.props.updateCardDetail
        })

    }

    render() {
         return (
             <div className={`update-card ${this.state.updateCardDetail ? "add-card-form" : ""}`}>

                  <br/>
                  <h2 className="text-center">Card details</h2>
                  <br/>

                      {
                          !Utils.isEmpty(this.state.error)
                          ?(
                            <div className="alert alert-warning" role="alert">
                                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                                <span className="sr-only">Error:</span>
                                {this.state.error}
                            </div>
                            )
                            :null
                      }


                      {
                            <form id="payment-form" autoComplete="on" onSubmit={this.createStripeCustomer}>
                              <div className="form-group">
                                <label htmlFor="cc-number" className="control-label">Card Number <small className="text-muted"> <span className="cc-brand"></span> </small></label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-credit-card"></i></span>
                                    <input
                                        name         = "cc-number"
                                        id           = "cc-number"
                                        type         = "tel"
                                        className    = "input-lg form-control cc-number"
                                        autoComplete = "cc-number"
                                        placeholder  = "•••• •••• •••• ••••"
                                        required
                                    />
                                </div>
                              </div>

                              <div className="form-group">
                                <label htmlFor="cc-exp" className="control-label">Card Expiry (MM/YYYY)</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-calendar"></i></span>
                                    <input
                                        name         = "cc-exp"
                                        id           = "cc-exp"
                                        type         = "tel"
                                        className    = "input-lg form-control cc-exp"
                                        autoComplete = "cc-exp"
                                        placeholder  = "•• / ••••"
                                        required
                                    />
                                </div>
                              </div>

                              <div className="form-group">
                                <label htmlFor="cc-cvc" className="control-label">Card CVC </label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-lock"></i></span>
                                    <input
                                        name         = "cc-cvc"
                                        id           = "cc-cvc"
                                        type         = "tel"
                                        className    = "input-lg form-control cc-cvc"
                                        autoComplete = "off"
                                        placeholder  = "•••"
                                        required
                                    />
                                </div>
                              </div>

                              <div className = "form-group">
                                  <label
                                      htmlFor   = "ZipCode"
                                      className = "control-label"
                                  >
                                      Zip Code
                                  </label>
                                <div className = "input-group">
                                    <span className = "input-group-addon">
                                        <i className = "fa fa-lock fa-default"></i>
                                    </span>
                                    <input
                                        type        = "text"
                                        placeholder = "Zip Code | Postal Code"
                                        title       = "Zip Code | Postal Code"
                                        onChange    = {this.changeZipCode}
                                        value       = {this.state.zipCode}
                                        className   = "input-lg form-control"
                                        required
                                        // pattern     = "(\d{5}([\-]\d{4})?)"
                                    />
                                </div>
                              </div>

                              <button
                                  type      = "submit"
                                  className = "payment btn btn-lg btn-block btn-export mt-20"
                              >
                                  Save
                              </button>
                              <div className="row" style={{'display':'none'}}>
                                  <div className="col-xs-12">
                                      <span className="payment-errors"></span>
                                  </div>
                              </div>
                              <h2 className="validation"></h2>
                          </form>
                      }
                  </div>
         );
    }
}



// WEBPACK FOOTER //
// src/components/dashboard/billing/add-card.js